export const uploadedContactListTableStyle = {
	table: {},
	container: {
		border: '1px solid var(--neutral-100)',
		borderRadius: '12px',
		padding: '20px 12px',
		maxHeight: 'calc(100vh - 380px)',
		overflowY: 'scroll',
		maxWidth: '1074px',
		margin: '0 auto',
	},

	tableRow: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
	},

	cell: {
		width: '100px',
		flexShrink: 0,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		padding: '0 8px',
	},

	title: {
		fontWeight: 'bold',
		marginBottom: '16px',
	},

	buttonWrapper: {
		display: 'flex',
		alignItems: 'center',
		position: 'fixed',
		gap: '24px',
		bottom: '24px',
		maxWidth: '1170px',
		width: '100%',
		height: '80px',
		padding: '0 100px',
		background: 'var(--neutral-100)',
		left: 'calc(50% - 585px)',
		borderRadius: '0 0 8px 8px',
	},

	button: {
		height: '44px',
		fontWeight: 700,

		'&.MuiButton-outlinePrimary': {
			backgroundColor: 'var(--neutral-100)',

			'&:hover': {
				backgroundColor: 'var(--primary-100)',
				color: 'var(--primary-500)',
			},
		},
	},
};
